import gql from 'graphql-tag'

import { AppLabelsQuery } from '../../../types/api'

export const labels = {
  query: gql`
    query AppLabels {
      labels {
        key
        value
      }
    }
  `,
  transformer: (response: AppLabelsQuery) => {
    return response.labels
  },
}
